import React from "react";

const NavigationItem = ({ icon, activeIcon, label, isActive, onClick }) => {
  return (
    <button
      onClick={onClick}
      className={`flex flex-col flex-1 shrink items-center basis-0 ${
        isActive ? "font-semibold text-indigo-600" : ""
      }`}
    >
      <img
        loading="lazy"
        src={isActive ? activeIcon : icon}
        alt={`${label} icon`}
        className="object-contain rounded-md aspect-square w-[30px]"
      />
      <span>{label}</span>
    </button>
  );
};

export default NavigationItem;
